<template>
    <div :class="PanelClass" v-if="isActive">
      
      <div  v-show="priorValid" class="availdiv">
        <div class="horizFlexStretch">
          <div class="product-lookup">
            <input ref="lookupproduct" type="search"  :placeholder="productlookuptext" class="textbox" v-model="productString" @keyup.enter="lookupProduct()" @input="searchchange"/>
            <button class="btn-small actionbutton" @click="lookupProduct">Lookup</button>
          
          </div>
          <div class="horizFlex">
            <div v-if="showReturn" >
              <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to start a return ticket?" title="Return Products" @yes="startreturn" v-if="!isReturn"/>
              <div class="vertcenter">
                <label v-if="isReturn" class="returnlabel">Is Return</label>
              </div>
              
            </div>
            <div v-if="showTaxExempt" >
              <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to make this ticket tax exempt?" title="Set Tax Exempt" @yes="taxexempt" v-if="!ticket.isTaxExempt"/>
              <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to make this ticket NOT tax exempt?" title="Set NOT Tax Exempt" @yes="taxexempt(false)" v-if="ticket.isTaxExempt"/>
            </div>
          </div>
         
        </div>
        
       <div v-if="pleaseWait">
          <label class="pleasewait" for>Please Wait...</label>
        </div>
  
        <!-- products from scan -->
        <div class="lineitemavailable" v-if="scannedItems.length!=0">
            <availableitem
              v-for="cartItem in scannedItems"
              v-bind:key="cartItem.id"
              v-bind:cartItem="cartItem" @additem="addScannedItem"
            />
       </div>
  
        <div>
          <hr>
        </div>
        
  
        <div class="lineitemavailable" v-if="availableCartItemTypes.length>1" >
            <availableitem
              v-for="cartItem in availableCartItemTypes"
              v-bind:key="cartItem.id"
              v-bind:cartItem="cartItem" @additem="setType(cartItem)"
            />
       </div>
  
      
  
      <!-- products filtered by type -->
       <div class="lineitemavailable scrollbox" v-if="!useProductGroups">
         <availableitem
          v-for="cartItem in filterCartItems"
          v-bind:key="cartItem.ID"
          v-bind:cartItem="cartItem" @additem="addCartItem"
        />
       </div>
        
        <!-- products by group -->
      <div class="lineitemavailable scrollbox" v-if="useProductGroups">
         <availableitem
          v-for="cartItem in cartItemsByGroup"
          v-bind:key="cartItem.ID"
          v-bind:cartItem="cartItem" @additem="addGroupCartItem"
        />
       </div>
  
      </div>
      <div class="lineitemadded " >
        <div class="cartlines">
          <div class="horizFlex" v-if="showSeatNumbers">
            <label for class="text subtitle">{{ cartTitle }}</label>
            <button class="btn-small actionbutton" @click="incrementCurrentSeatNumber">Next</button>
            <linkbutton class="prevseatlink"  @click="deccrementCurrentSeatNumber" toplabel='Previous'/>
          </div>
          <div v-if="!showSeatNumbers">
            <label for class="text subtitle">{{ cartTitle }}</label>
          </div>

           <!-- <addtip :showButton="trueParam" buttonClass="btn-small "/> -->
            <div class="cartitemdiv">
              <CartItem v-for="cartItem in cartItems" v-bind:key="cartItem.id" v-bind:cartItem="cartItem"  @removeitem="removelineitem" @refresh="refresh"  @updatequantity="updateitemquantity" @returnitem="returnitem"/>
            </div>
          
          <label for class=" text-right carttotaltext">Subtotal: {{ ticket.subTotal|toCurrency }}</label>
   
          <label for class=" text-right carttotaltext discountcolor" >Discount: {{ ticket.discountAmount|toCurrency }}</label>
          <div class="rightjustify disclink">
            <admindiscountwhole :ticketId="ticket.id" v-if="ShowAdminDiscount" @refresh="refresh"/>
          </div>
            
          <!-- <label for class=" text-right carttotaltext">Tips: {{ ticket.tipTotal|toCurrency }}</label>   -->
          <label for class=" text-right carttotaltext">Tax: {{ ticket.tax|toCurrency }}</label>
          <label for class=" text-right carttotaltext paycolor">Due: {{ ticket.total|toCurrency }}</label>
          <label class="eligiblemessage"  v-if="cartEligibleForFA">*All items in Cart Eligible For Financial Aid*</label>
        </div>
        
        <div class="nextbutton">
          <div class="horizFlex" v-if="!allItemsInKitchen()">
            <button class="btn actionbutton" @click="toKitchen" v-show="isValid && ticket.total!=0">Send to Kitchen</button>
            <button class="btn actionbutton" @click="toKitchenAndPay" v-show="isValid && ticket.total!=0">Send to Kitchen and Pay Now</button>
          </div>
          <div class="horizFlex" v-if="allItemsInKitchen()">
            <button class="btn actionbutton" @click="toNext" v-show="isValid && ticket.total!=0 ">Continue to Payment</button>
          </div>
        </div>
      </div>
  
      <giftcard :showButton="trueParam" ref="giftcard" @save="saveGiftCard"/>
      <setprice ref="setprice" :minimumUnitPrice="productToGetPrice.minimumUnitPrice" @save="saveProductWithVariablePrice"/>
      <productoptions ref="productOptions" @save="saveProductWithOptions" :productName="productToGetOptions.name" :showButton="falseParam"/>
      <tokitchen ref="tokitchen" />
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import CartItem from "../actions/CartItem.vue";
  import availableitem from '../actions/availableitem.vue'
  import format from '../../style/format.js'
  import giftcard from '../actions/giftcard.vue'
  import setprice from '../actions/setprice.vue'
  import confirm from '../actions/confirm.vue'
  import admindiscountwhole from '../actions/admindiscount_whole.vue'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js';
  import productoptions  from '../actions/productoptions.vue';
  import tokitchen from '../actions/tokitchen.vue';
   import addtip from '../actions/addtip.vue'
   import linkbutton from '../controls/linkbutton.vue'
  export default {
    data() {
      return {
        // availableCartItems_filtered:[],
        
        productlookuptext:'Lookup Product',
        trueParam:true,
        falseParam:false
        
       
      };
    },
    props: ["panelIndex"],
    mixins:[format,pos,pos_culinary],
    components: {
      CartItem,
      availableitem,
      giftcard,
      admindiscountwhole,
      setprice,
      confirm,
      productoptions,
      tokitchen,
      addtip,
      linkbutton
    },
    computed: {
      ...mapFields([
              'panels',
  
              
          ]),
     
     
    
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      PanelClass: function() {
        var classes = "panel-full-culinary panel cartfull ";
        if (this.inPayment == true) {
          classes += " panel-unavailable";
        }
        return classes;
      },
      
       
    },
    watch:{
      isActive:function(val){
        if(this.isActive){this.show()}
      }
    },
    methods: {
      
      refresh(){
        this.$emit('refreshticketrebuild')
      },
      show(){
        this.$nextTick(() => {
          this.$refs.lookupproduct.focus();
        })
     },
     searchchange(event){
        if(event.target.value.trim().length===0){
          this.scannedItems=[]
        }
     },
      
  
      
      
      
      toKitchenAndPay: function() {
        this.lookupString=""
        this.sendtickettokitchen(true,this.panelIndex)//still send to kitchen but with flag to pay
       // var nextPanelIndex = Number(this.panelIndex) + 1;
        //this.$store.dispatch('setActivePanel',nextPanelIndex);
      },
      toKitchen(){
        this.sendtickettokitchen();
      },
      toComplete: function() {
        this.lookupString=""
  
        if(this.AutoStartOver)      {
          this.startOver();
        }else{
          var nextPanelIndex = Number(this.panelIndex) + 2;
          this.$store.dispatch('setActivePanel',nextPanelIndex);
        }
        
      },
      toNext: function() {

        if(this.addingProduct){return}
        //if its a return, and we are doing inventory stuff, ask
        if(this.isReturn && this.AskInventoryForReturn ){
          this.checkReturn()
          return
        }

        this.lookupString=""
        var nextPanelIndex = Number(this.panelIndex) + 1;
        this.$store.dispatch('setActivePanel',nextPanelIndex);
      },
      startOver: function() {
        this.$store.dispatch('startOver');
      },
      
    },
    
    
  };
  </script>
  
  <style scoped>
  
  .cartfull {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      "itemavailable itemadded";
    padding: 10px;
  }
  
  .lineitemavailable {
    /* grid-area: itemavailable; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    
  }
  .lineitemadded {
    grid-area: itemadded;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto 60px;
    grid-template-areas:
      "itemadded"
      "next";
    padding: 10px;
  
  
    /* display: flex;
    flex-direction: column;
    border-left: 1px solid gray;
    padding-left:20px;
    margin-left:10px; */
  }
  .cartlines{
    display: flex;
    flex-direction: column;
    border-left: 1px solid gray;
    padding-left:20px;
    margin-left:10px;
    
  }
  .cartitemdiv{
    max-height:30vh;
    overflow-y: auto;
    overflow-x:hidden;
  }
  .product-lookup {
  
    display: flex;
    flex-direction: row;
  }
  .scrollbox{
    max-height:42vh;
    /* max-height:100%; */
    overflow-y: auto;
    overflow-x:hidden;
  
  }
  .disclink{
    margin-right:10px;
    font-size:inherit;
  }
  .returnlabel{
    font-size:larger;
    font-weight:bold;
    margin:0px 0px 0px 0px;
    color:red;
  }
  .vertcenter{
    
    padding-top:10px;
    
  }
  .carttotaltext{
    /* font-size:larger; */
    margin:3px 5px 3px 3px;
  }
  .prevseatlink{
    margin-top:15px;
  }
  </style>